import c from '../common';

export default{
    "intro": c.intro.en,
    "shopAddress" : "Shop Address",

    "OpeningHour":"Opening hour",

};